// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAVcI4E2bAMELACv1dKzGlRQB0or9NKIiA",
    authDomain: "medica-390f6.firebaseapp.com",
    projectId: "medica-390f6",
    storageBucket: "medica-390f6.appspot.com",
    messagingSenderId: "353138787269",
    appId: "1:353138787269:web:d700dc93c61838b75e01ac"
};

export default firebaseConfig;